import { render } from "./InvoiceUnissued.vue?vue&type=template&id=2dd742b6&scoped=true"
import script from "./InvoiceUnissued.vue?vue&type=script&lang=js"
export * from "./InvoiceUnissued.vue?vue&type=script&lang=js"

import "./InvoiceUnissued.vue?vue&type=style&index=0&id=2dd742b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd742b6"]])

export default __exports__